import { useParams } from 'react-router-dom';

import { AppUpdateIapPollPage } from '~/components/pages/AppUpdateIapPollPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppUpdateIapPollRoute: React.FC = () => {
  const { appId, iapPollId } = useParams();
  const navigate = useNavigate();

  if (!appId) {
    navigate('/');

    return null;
  }

  if (!iapPollId) {
    navigate(`/apps/${appId}/iapPolls`);

    return null;
  }

  return (
    <DashboardTemplate appId={appId} noAppPreviewOverlap>
      <AppUpdateIapPollPage appId={appId} iapPollId={iapPollId} />
    </DashboardTemplate>
  );
};
